import { render, staticRenderFns } from "./EmissionsResult.vue?vue&type=template&id=5109b4f3&lang=html&"
import script from "./EmissionsResult.vue?vue&type=script&lang=js&"
export * from "./EmissionsResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports